//import update from 'immutability-helper';

const emptyState = {
  onAttributionsPage: false
}

const AttributionsReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE": {
      let { pathname="" } = action.payload;
      let newSelectedPage = pathname.replace(/^\/|\/$/g, '');
      if (newSelectedPage === "attributions") {
        return {...state, onAttributionsPage: true};
      }
      return {...state, onAttributionsPage: false};
    }
    default: {
      return state
    }
  }
}

export default AttributionsReducer